import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export type Interval = { opens_at: string; closes_at: string };
export type WeeklySchedule = Record<string, Interval[]>;
export const weekDays = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

export function WeeklyScheduleFields({
  schedule,
  onChange,
}: {
  schedule: WeeklySchedule;
  onChange: (value: WeeklySchedule) => void;
}) {
  const { t } = useTranslation();
  return (
    <div className="space-y-4">
      {weekDays.map((day) => {
        const intervals = schedule[day] || [];
        const update = (value: Interval[]) =>
          onChange({ ...schedule, [day]: value });
        return (
          <fieldset key={day} className="space-y-2 rounded-md border p-3">
            <legend className="px-1 text-sm font-medium">
              {t(`days.${day}`)}
            </legend>
            {intervals.length === 0 && (
              <p className="text-muted-foreground text-sm">
                {t("schedule_ui.closed")}
              </p>
            )}
            {intervals.map((interval, index) => (
              <div
                key={index}
                className="grid min-w-0 grid-cols-1 items-end gap-2 @min-[36rem]/form-content:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_auto]"
              >
                {(["opens_at", "closes_at"] as const).map((field) => (
                  <label key={field} className="grid min-w-0 gap-2 text-sm">
                    <span>{t(`schedule_ui.${field}`)}</span>
                    <Input
                      type="time"
                      required
                      aria-label={`${t(`days.${day}`)} ${index + 1} ${t(`schedule_ui.${field}`)}`}
                      value={interval[field]}
                      onChange={(event) =>
                        update(
                          intervals.map((value, position) =>
                            position === index
                              ? { ...value, [field]: event.target.value }
                              : value,
                          ),
                        )
                      }
                    />
                  </label>
                ))}
                <Button
                  type="button"
                  variant="ghost"
                  className="w-fit"
                  onClick={() =>
                    update(
                      intervals.filter((_, position) => position !== index),
                    )
                  }
                >
                  {t("maps.interval_remove")}
                </Button>
              </div>
            ))}
            <Button
              type="button"
              variant="outline"
              size="sm"
              onClick={() =>
                update([
                  ...intervals,
                  { opens_at: "09:00", closes_at: "17:00" },
                ])
              }
            >
              {t("maps.interval_add")}
            </Button>
          </fieldset>
        );
      })}
    </div>
  );
}
